import React, { useCallback, useState } from 'react'
import cls from 'classnames'
import { withRouter } from 'react-router-dom'

import { URL_CONST } from 'utils/urlConsts'

import { SETUP_STEPS } from 'containers/Navigation/AccountSetup/constants'

import CenteredLoader from 'components/lib/CenteredLoader'
import Button from 'components/lib/DesignSystem/Button'
import { Lounch } from 'components/lib/DesignSystem/Icons'
import Modal from 'components/lib/DesignSystem/Modal'

const DEFAULT_KB_LABEL = 'Read more in our Knowledge Base'

function Step({
  data,
  loader,
  history,

  closePopup,
  toggleDismiss,

  isStaticSalesDemo,
}) {
  const stepData = SETUP_STEPS[data.step] || {}
  const [showVideoModal, setShowVideoModal] = useState(false)

  const onCloseVideoModal = useCallback(() => {
    setShowVideoModal(false)
  })

  const handleShowVideoModal = useCallback(() => {
    setShowVideoModal(true)
  })

  const handleRedirect = useCallback(() => {
    if (isStaticSalesDemo) return
    closePopup()
    if (stepData.url === URL_CONST.mailboxes.management) {
      history.push({
        pathname: URL_CONST.mailboxes.management,
        state: { vipUserModal: true },
      })
    } else {
      history.push(stepData.url)
    }
  })

  const handleToggleDismiss = useCallback(() => {
    if (isStaticSalesDemo) return
    toggleDismiss({ ...data, dismissed: !data.dismissed })
  }, [data.dismissed])

  const handleOpenKB = useCallback(() => {
    if (isStaticSalesDemo) return
    window.open(stepData.kb, '_blank')
  })

  return (
    <div className={cls('step-item', { marked: data.complete || data.dismissed })}>
      <div className="dib-vac marked-indication" id={`accountSetup-marked-indication-${data.step}`}>
        {data.complete ? (
          <img src="/static/webapp/images/navigation/valid-icon.svg" className="mr" />
        ) : (
          <div className="unmarked-step dib-vac" />
        )}
      </div>
      <div className="step-text dib-vac">
        <div
          id={`accountSetup-${data.step}`}
          className={cls('text-indication', 'dib-vac', { cp: stepData.url })}
          onClick={stepData.url ? handleRedirect : undefined}
        >
          {stepData.text}
        </div>
        <div className="dib-vac step-actions">
          <div>
            {stepData.modal ? (
              <img
                className="w20"
                src="/static/webapp/images/play-blue.svg"
                onClick={handleShowVideoModal}
              />
            ) : (
              <>
                {!!stepData.kb && (
                  <Lounch width="16px" height="16px" className="kb-icon" onClick={handleOpenKB} />
                )}
              </>
            )}
          </div>
          <div>
            {!data.complete && (
              <>
                {loader ? (
                  <CenteredLoader type="ball-clip-rotate" />
                ) : (
                  <img
                    className="w15"
                    src={
                      data.dismissed
                        ? '/static/webapp/images/return-arrow.svg'
                        : '/static/webapp/images/x-icon-modal.svg'
                    }
                    onClick={handleToggleDismiss}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        open={showVideoModal}
        accountSetupVideoModal
        onClose={onCloseVideoModal}
        title={stepData.text}
        width="800px"
        footer={stepData.modal?.kbLinks.map((e, i) => (
          <Button
            key={e.label}
            id={`read_more-${i}`}
            text={e.label || DEFAULT_KB_LABEL}
            LeftIconDS={Lounch}
            dsIconStyles={{ fill: '#0152CC', height: '20px', width: '20px' }}
            styleType="tertiary"
            onClick={() => window.open(e.link, '_blank')}
          />
        ))}
      >
        <iframe
          width="740"
          height="385"
          src={stepData.modal?.video}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ marginTop: '30px', marginBottom: '20px' }}
          title={stepData.text}
        />
      </Modal>
    </div>
  )
}

export default withRouter(Step)
